import {stringify} from 'qs';
import {createSelector} from 'reselect';

import {Controller} from '@stubhub/react-store-provider';
import {get} from '@stubhub/rest-method';

import {SEARCH_CACHE_MAX_AGE} from '../../utils/constants';

const ACTION_TYPES = {
  NEARBY_VENUES_LOADED: 'NEARBY_VENUES_LOADED',
  NEARBY_VENUES_RESET: 'NEARBY_VENUES_RESET',
};

const namespace = 'venue.nearbyVenues';

const venueLinksSelector = createSelector(
  (localState = {}) => localState.venueLinks,
  (venueLinks) => venueLinks,
);

const loadNearbyVenues = (props) => {
  return (dispatch, getState) => {
    const STATE = getState();
    const cache = true;
    const cacheMaxAge = SEARCH_CACHE_MAX_AGE;
    const {entityId, lat, lng} = props;
    const searchOptions = {
      point: `${lat},${lng}`,
      sort: 'distance asc',
      fieldList: 'id,url,name',
      rows: 25,
      radius: '5000',
      status: 'active',
    };

    const {lang} = STATE;

    return get({
      host: process.env.REACT_APP_API_HOST,
      path: `/search/catalog/venues/v3/?${stringify(searchOptions)}`,
      headers: {
        Authorization: process.env.REACT_APP_API_SECRET,
        'Accept-Language': lang,
      },
      json: true,
      cache,
      cacheMaxAge,
    }).then((body) => {
      const {venues = []} = body;
      const venueLinks = pickNearbyVenues(venues, entityId);
      dispatch({type: ACTION_TYPES.NEARBY_VENUES_LOADED, venueLinks});

      return null;
    });
  };
};

const FILTERED_VENUES_COUNT = 20;
const pickNearbyVenues = (venues = [], entityId) =>
  venues.filter((venue) => parseInt(entityId) !== venue.id).slice(0, FILTERED_VENUES_COUNT);

const resetNearbyVenues = () => {
  return (dispatch) => {
    dispatch({type: ACTION_TYPES.NEARBY_VENUES_RESET});
  };
};

const controller = new Controller({
  namespace,
  mapStateToProps(state) {
    const localState = this.getLocalState(state);

    return {
      venueLinks: venueLinksSelector(localState),
    };
  },
  actionCreators: {
    resetNearbyVenues,
    loadNearbyVenues,
  },
  reducers: [ACTION_TYPES.NEARBY_VENUES_LOADED, ACTION_TYPES.NEARBY_VENUES_RESET],
});

controller.addResetReducer([ACTION_TYPES.NEARBY_VENUES_RESET]);

export default controller;
